<template>
  <v-app id="app">
    <BaseConfirm ref="baseConfirm" />
    <router-view style="height: 100%" />
  </v-app>
</template>

<script>
import BaseConfirm from './components/baseConfirm.vue'
export default {
  name: 'App',
  components: {
    BaseConfirm
  },
  mounted () {
    this.$root.moment = require('moment')
    this.$root.$confirm = this.$refs.baseConfirm
  }
}
</script>
<style lang="scss" scoped>

// $myFont: Helvetica, sans-serif;
// $myColor: red;
// $myFontSize: 18px;
// $myWidth: 680px;

// body {
//   font-family: $myFont;
//   font-size: $myFontSize;
//   color: $myColor;
// }
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
// #container {
//   width: $myWidth;
// }
</style>
